module.exports = __webpack_public_path__ + "img/mozartschnitte.3abf195a.jpg";